// import { Close, MenuOutlined } from "@material-ui/icons";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/shercodes_logo.png";
import "./Navbar.css";

import { AiOutlineClose } from "react-icons/ai";
import { GiHamburgerMenu } from "react-icons/gi";

const Navbar = () => {
  const [active, setActive] = useState(false);

  const showHam = () => {
    setActive(!active);
  };
  const [navbar, setNavbar] = useState(false);
  const changeBackground = () => {
    console.log(window.scrollY);
    if (window.scrollY >= 66) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  useEffect(() => {
    changeBackground();
    // adding the event when scroll change background
    window.addEventListener("scroll", changeBackground);
  });

  // function refreshPage() {
  //   window.location.reload();
  // }
  return (
    <nav className={navbar ? "navbar active" : "navbar"}>
      <div className="header">
        <div className="logo">
          <Link to="/Portfolio/">
            {" "}
            <img
              src={logo}
              alt="shercodes logo"
              style={{ width: "70px", height: "70px" }}
            />
          </Link>{" "}
        </div>
        <nav>
          <ul className={active ? "list-items active" : "list-items"}>
            <div className="close-icon">
              <AiOutlineClose className="close" onClick={showHam} />{" "}
            </div>
            <li>
              <a
                href="https://github.com/onib0002"
                target="_blank"
                rel="noopener noreferrer"
              >
                Github{" "}
              </a>{" "}
            </li>{" "}
            <li>
              <Link to="/Portfolio/projects">Projects </Link>{" "}
            </li>{" "}
            <li>
              <a
                href="https://www.linkedin.com/in/gbemisolasulaiman/"
                target="_blank"
                rel=" noopener noreferrer"
              >
                Linkedin{" "}
              </a>{" "}
            </li>{" "}
            <li>
              <a
                href="https://drive.google.com/file/d/1c6yOsEo9JZEoGlL_OHVwU99N24KmBwDi/view?usp=sharing"
                target="_blank"
                rel=" noopener noreferrer"
              >
                Resume{" "}
              </a>{" "}
            </li>{" "}
            <li>
              <a
                href="https://shercodes.hashnode.dev/"
                target="_blank"
                rel=" noopener noreferrer"
              >
                Blog{" "}
              </a>{" "}
            </li>{" "}
            <li>
              <Link to="/Portfolio/contacts">Contact </Link>{" "}
            </li>{" "}
          </ul>{" "}
        </nav>
        <div className="menu-icon">
          <GiHamburgerMenu className="icon" onClick={showHam} />{" "}
        </div>{" "}
      </div>
    </nav>
  );
};

export default Navbar;
